<div class="close-container">
    <mat-icon class="close-icon" (click)="dialogRef.close()"></mat-icon>
</div>
<div class="title title--lg dialog" mat-dialog-title>Removal Confirmation</div>
<mat-dialog-content>
    <div class="list-font">Are you sure you want to remove this resident?</div>
    <div class="list-font resident-name">{{data.lastName}}, {{data.firstName}}</div>
    <div class="list-font resident-name">{{data.institutionalEmailAddress}}</div>
    <div class="error" *ngIf="removeResidentError">There was an error in removing the resident.
            If the error persists please contact Customer Service.</div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="btn--inline dialog-btn-container">
        <button [disabled]="removeResidentError" (click)="removeResident()" class="btn btn--solid btn--red">Remove</button>
        <button (click)="dialogRef.close()" class="btn btn--outline">Cancel</button>
    </div>
</mat-dialog-actions>
<aaos-spinner [isLoading]="loading"></aaos-spinner>
